import { type BaseMicroservicesResponse } from "@/lib/@types/api/base";
import { type MediaType } from "@/lib/@types/api/media";
import { message } from "antd";

const baseUrl = process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL;
// const baseUrl = "http://43.132.233.53:28000";

// 获取电子书列表
export const getEbookList = async (data: any) => {
    try {
        const res: any = await fetch(`${baseUrl}/medias/get_ebook_list`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "lang": data?.lang_code?.lang_code || "en",
                "Content-Type": "application/json"
            },
        })

        if (res.status === 200) {
            const result = await res.json();
            return result;
        } else {
            console.error("Failed to fetch ebook list, status:", res.status);
            return { detail: { ebook_list: [] } };
        }
    } catch (error) {
        console.error("Error fetching ebook list:", error);
        message.error("Fail to fetch data");
        return { detail: { ebook_list: [] } };
    }
};

// 获取电子书详情
export const getEbookDetail = async (data: any) => {
    return new Promise((resolve, reject) => {
        fetch(`${baseUrl}/medias/ebook_detail`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            },
        }).then(async (r: any) => {
            const res = await r.json();
            if (res.code === 200) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(null);
        });
    })
};

// 下载电子书
export const downloadEbook = async (data: any, locale: string) => {
	return new Promise(async (resolve, reject) => {
		try {
			// 1. 先调用电子书详情接口获取文件信息
			const ebookDetail: any = await getEbookDetail({
				lang_code: {
					lang_code: locale || "zh-Hans",
				},
				book_id: data.ebook_id,
			});
			if (!ebookDetail || !ebookDetail.detail) {
				throw new Error("Failed to fetch ebook details");
			}

			// console.log(ebookDetail, "ebookDetail======================");

			// 2. 从详情中提取文件名和文件类型
			const { e_book_detail } = ebookDetail.detail;
			const filename = e_book_detail.book_file_name;

			// console.log(filename, "filename======================");
			// 3. 调用下载接口
			const res = await fetch(`${baseUrl}/medias/get_ebook`, {
				method: "POST",
				body: JSON.stringify(data),
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (res.ok) {
				const blob = await res.blob();
				// 创建一个指向Blob对象的URL
				const urlObject = URL.createObjectURL(blob);
				// 创建一个<a>元素并模拟点击以下载文件
				const a = document.createElement("a");
				a.href = urlObject;
				a.download = filename;
				document.body.appendChild(a);
				a.click();
				resolve(res);
			} else {
				reject("Failed to download ebook");
			}
		} catch (error) {
			console.error("Download error:", error);
			reject(error);
		}
	});
};


// 电子书分类查询
export const getEbookCategoryFilter = async (data: {
	lang_code: { lang_code: string };
	keyword?: string;
	level?: number;
}) => {
	try {
		const res: any = await fetch(`${baseUrl}/medias/ebook_category_filter`, {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"lang": data?.lang_code?.lang_code || "en",
				"Content-Type": "application/json"
			},
			next: { revalidate: 60 }
		});

		if (res.status === 200) {
			const result = await res.json();
			return result;
		} else {
			const errorText = await res.text();
			return { detail: { category_list: [] } };
		}
	} catch (error) {
		return { detail: { category_list: [] } };
	}
};

// 电子书分类子分类查询
export const getEbookChildrenCategory = async (params: {
	parent_cls_id: string | number;
	lang_code: string;
}) => {
	try {
		const queryParams = new URLSearchParams({
			lang_code: params.lang_code
		});

		const res: any = await fetch(`${baseUrl}/medias/ebook_children_category/${params.parent_cls_id}?${queryParams}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json"
			},
			next: { revalidate: 60 }
		});

		if (res.status === 200) {
			const result = await res.json();
			// console.log('📡 getEbookChildrenCategory API 返回:', result);
			return result;
		} else {
			// console.error("Failed to fetch ebook children category, status:", res.status);
			return { detail: { cls_list: [] } };
		}
	} catch (error) {
		// console.error("Error fetching ebook children category:", error);
		message.error("Fail to fetch data");
		return { detail: { cls_list: [] } };
	}
};

// 电子书分类详情查询
export const getEbookCategoryDetail = async (params: {
	cls_id: string | number;
	lang_code: string;
}) => {
	try {
		const queryParams = new URLSearchParams({
			cls_id: params.cls_id.toString(),
			lang_code: params.lang_code
		});

		const res: any = await fetch(`${baseUrl}/medias/ebook_category_detail?${queryParams}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json"
			},
			next: { revalidate: 60 }
		});

		if (res.status === 200) {
			const result = await res.json();
			return result;
		} else {
			console.error("Failed to fetch ebook category detail, status:", res.status);
			return { detail: null };
		}
	} catch (error) {
		console.error("Error fetching ebook category detail:", error);
		message.error("Fail to fetch data");
		return { detail: null };
	}
};

// 图片url批量查询
export const getBulkImage = async (data: any) => {
    try {
        const res: any = await fetch(`${baseUrl}/medias/get_bulk_image`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "lang": "en",
                "Content-Type": "application/json"
            },
        })

        return res.status === 200 ? res.json() : [];
    } catch (error) {
        message.error("Fail to fetch data");
        return [];
    }
};